export { default } from './getStylesCreator';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/getStylesCreator/index.js
// module id = 1718
// module chunks = 121